import React, { useEffect, useRef, useState } from "react";

import ProductSearchList from "./ProductSearchList";
import handleError from "./handleError";
import AxiosInstance from "../utils/AxiosInstance";
import { useShowAlert } from "../context/AlertContext";
import { useNetwork } from "../context/NetworkContext";
import SearchInput from "./SearchInput";

const CustomerSelector = ({ onSelectCustomer,setError}) => {
  const customerWrapperRef = useRef(null)
  const controllerRef = useRef(null);
  const debounceTimerRef = useRef(null);
  const suggestionRefs = useRef([]);
  const customerSuggestionsRef = useRef(null);
  const [isCustomerData, setCustomerData] = useState(null);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();//editData?.customer)
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const handleCustomerSearch = (term) => {
      setCustomerSearchTerm(term);
      if (term.trim() === "") {
        setCustomerSuggestions([]);
        setCustomerData(null);
        return;
      }
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
      debounceTimerRef.current = setTimeout(async () => {
        try {
          setIsCustomerLoading(true);
          if (!checkNetwork()) return;
          controllerRef.current = new AbortController();
          const response = await AxiosInstance.get(
            `module/customer/search?searchtxt=${encodeURIComponent(term.trim())}`,
            { signal: controllerRef.current.signal },
          );
          setCustomerSuggestions(response.data.results || []);
          const data = { phone: "", name: "" };
          if (/^\d+$/.test(term.trim())) {
            data.phone = term.trim();
          } else {
            data.name = term.trim();
          }
          setCustomerData(data);
        } catch (error) {
          if (error.name !== "CanceledError" && error.name !== "AbortError") {
            handleError(error, showAlert);
          }
        } finally {
          setIsCustomerLoading(false);
        }
      }, 200);
    };
  const handleSelectCustomer = async (customer) => {
        try {
          if (!checkNetwork()) return;
          const response = await AxiosInstance.get(
            `module/customer/details/${customer._id}`,
          );
          const fullCustomer = response.data.results;
          setSelectedCustomer(fullCustomer.customerData);
          onSelectCustomer?.(fullCustomer.customerData);
          setCustomerSearchTerm("");
          setCustomerSuggestions([]);     
    
         
        } catch (error) {
          handleError(error, showAlert);
        }    
       
  };
    const handleCustomerModalOpen = () => {
    // setSelectedCustomer(null);
    setCustomerModalOpen(true);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        customerWrapperRef.current &&
        !customerWrapperRef.current.contains(event.target)
      ) {
        setShowCustomerDropdown(false);
        setHighlightedIndex(-1);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); 
    const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        // amountRef.current[0]?.focus();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer?.name?.toLowerCase() === trimmedSearch?.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        customerSuggestionsRef.current?.focus();
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  }; 
  return (
    <div className="card mb-2">
      <div className="card-body">
        <div
          className="ms-auto position-relative"
          ref={customerWrapperRef}
        >
          <SearchInput
            searchRef={customerSuggestionsRef}
            value={customerSearchTerm}
            onChange={(e) => {
              handleCustomerSearch(e.target.value);
              setShowCustomerDropdown(true);
              setHighlightedIndex(-1);
              setError("")
            }}
            onFocus={() => {
              if (customerSuggestions.length > 0) {
                setShowCustomerDropdown(true);
              }
            }}
            onSearch={
              customerSearchTerm.trim()
                ? () =>
                    handleCustomerModalOpen(
                      customerSearchTerm.trim()
                    )
                : null
            }
            placeholder="Search customer by name, phone, email, referenceID..."
            onKeyDown={handleCustomerKeyDown}
          />

          {customerSearchTerm &&
            customerSuggestions.length === 0 && (
              <ul className="suggestions-list">
                <li className="suggestion-item text-muted">
                  No customers data was found
                </li>
              </ul>
            )}

          {showCustomerDropdown &&
            customerSuggestions.length > 0 && (
              <ProductSearchList
                suggest={customerSuggestions}
                suggestionRefs={suggestionRefs}
                handleSelect={handleSelectCustomer}
                activeIndex={highlightedIndex}
                type="customer"
              />
            )}
        </div>

        <div className="col-lg-12 mt-1">
          <div className="card shadow-none border-blue mb-0">
            <div className="card-header bg-label-orange p-2 d-flex justify-content-between align-items-center">
              <div>Customer Info</div>

              {/* {selectedCustomer && (
                <button
                  type="button"
                  className="btn-label-orange rounded shadow-none border-0"
                  onClick={() => openEditModal(selectedCustomer)}
                >
                  <i className="ng ng-ng-edit-icon"></i>
                </button>
              )} */}
            </div>

            <div className="card-body px-2 py-0">
              {selectedCustomer ? (
                <>
                  <p className="my-1 fs-13">
                    Name :
                    <span className="fw-600 fs-14">
                      {" "}
                      {selectedCustomer.name}
                    </span>
                  </p>

                  <p className="my-1 fs-13">
                    Phone :
                    <span className="fw-600 fs-14">
                      {" "}
                      {selectedCustomer.phone}
                    </span>
                  </p>
                </>
              ) : (
                <p className="my-2 text-muted">
                  No customers has been selected
                </p>
              )}
            </div>
          
          </div>
           
        </div>         
      </div>
    </div>
  );
};

export default CustomerSelector;